// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

// ─── Alarms Route ─────────────────────────────────────────────────────────────
// This route serves as a parent for all alarm-related routes.
// It checks if the user has access to the Alarms service and renders the appropriate child route or an error message if access is denied.
// The ServiceGuard component is used to protect the route, ensuring that only users with access to the Alarms service can view the content.
export const Route = createFileRoute('/$accountId/_user/alarms')({
  component: () => (
    <ServiceGuard
      serviceNames={['Alarms']}
      fallback={<Navigate to="/$accountId" />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'glossary:alarms' },
});
